var AWSAuthServiceModule = /** @class */ (function () {
    function AWSAuthServiceModule() {
    }
    return AWSAuthServiceModule;
}());
export { AWSAuthServiceModule };
